<script>
import Label from "./Label.vue";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
  },
  data() {
    return {
      rerender: true,
      value: this.item_value,
      d_check: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn]) ==
            this.item.displayOnValue
          : this.selectedItem[this.item.displayOn] == this.item.displayOnValue
        : false,
      d_check2: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn2] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn2]) ==
            this.item.displayOnValue2
          : this.selectedItem[this.item.displayOn2] == this.item.displayOnValue2
        : false,
      d_check3: this.selectedItem
        ? typeof this.selectedItem[this.item.displayOn3] != "string"
          ? JSON.stringify(this.selectedItem[this.item.displayOn3]) ==
            this.item.displayOnValue3
          : this.selectedItem[this.item.displayOn3] == this.item.displayOnValue3
        : false,
      disable_check:
        this.selectedItem &&
        this.item.disableOn &&
        this.selectedItem[this.item.disableOn]
          ? false
          : true,
      currentImageUrl: "", // Track current image URL for reactivity
      localCqcRating: this.selectedItem?.additionalProp1?.cqc_option || "",
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.d_check;
      },
      set: function (newValue) {
        this.d_check = newValue;
      },
    },
    display_none_check2: {
      get: function () {
        return this.d_check2;
      },
      set: function (newValue) {
        this.d_check2 = newValue;
      },
    },
    display_none_check3: {
      get: function () {
        return this.d_check3;
      },
      set: function (newValue) {
        this.d_check3 = newValue;
      },
    },
    cqcRatingMap() {
      return {
        "Outstanding": "",
        "Good": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/Good+badge.png",
        "Requires improvement": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/requries-improvement-badge.png",
        "Inadequate": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/inadequate-badge.png",
        "Not rated": "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/General/not-rated-badge.png"
      };
    },
    imageUrl() {
      console.log("ImagePreview - imageUrl computed", {
        item_key: this.item_key,
        displayURL: this.item.displayURL,
        localCqcRating: this.localCqcRating,
        rerender: this.rerender
      });
      
      // Check if this is a CQC rating preview
      if (this.item_key === 'cqc_preview' && this.item.displayURL === 'cqc_option') {
        const rating = this.localCqcRating;
        const badgeUrl = this.cqcRatingMap[rating] || "";
        console.log("CQC Badge URL:", { rating, badgeUrl });
        return badgeUrl;
      }
      
      // Default behavior for regular image preview
      const regularUrl = this.selectedItem?.[this.item.displayURL] || "";
      console.log("Regular image URL:", regularUrl);
      return regularUrl;
    },
  },
  watch: {
    item_value: {
      handler(val) {
        this.value = val;
      },
      deep: true,
    },
    value(val) {
      this.updateValue(this.item_key, val);
    },
    display_none_check(val) {
      this.item.display = this.item.displayOn && !val ? false : true;
    },
    display_none_check2(val) {
      this.item.display = this.item.displayOn2 && !val ? false : true;
    },
    display_none_check3(val) {
      this.item.display = this.item.displayOn3 && !val ? false : true;
    },
    // Watch for CQC rating changes via last_updated
    last_updated: {
      handler(val) {
        // Handle display logic
        this.handledisplay();
        
        // Handle CQC option changes
        if (val && val.key === 'cqc_option' && this.item_key === 'cqc_preview') {
          console.log("CQC option changed via last_updated:", { 
            oldVal: val.oldValue,
            newVal: val.value,
            item_key: this.item_key
          });
          
          this.localCqcRating = val.value;

          // Force re-render
          this.rerender = false;
          this.$nextTick(() => {
            this.rerender = true;
            this.$forceUpdate();
            console.log("CQC preview re-rendered");
          });
        }
      },
      deep: true,
    },
    // Also watch selectedItem changes directly
    'selectedItem.additionalProp1.cqc_option': {
      handler(newVal, oldVal) {
        if (this.item_key === 'cqc_preview') {
          console.log("CQC option changed directly:", { oldVal, newVal });
          this.localCqcRating = newVal;
          this.rerender = false;
          this.$nextTick(() => {
            this.rerender = true;
            this.$forceUpdate();
          });
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.item.display = false;
    console.log("mounted called");
  },
  methods: {
    handledisplay() {
      let val = this.last_updated;
      this.rerender = false;

      if (val && this.item.displayOn && val.key == this.item.displayOn) {
        console.log("val.value", val, typeof val.value);

        if (typeof val.value == "object") {
          console.log("second conditoin", val.value, val.value.name);
          this.display_none_check =
            val.value.name == this.item.displayOnValue ? true : false;
          console.log(" this.display_none_check", this.display_none_check);
        } else if (typeof val.value != "string") {
          this.display_none_check =
            JSON.stringify(val.value) == this.item.displayOnValue
              ? true
              : false;
        } else {
          this.display_none_check =
            val.value == this.item.displayOnValue ? true : false;
        }
      }
      if (val && this.item.displayOn2 && val.key == this.item.displayOn2) {
        if (typeof val.value != "string") {
          this.display_none_check2 =
            JSON.stringify(val.value) == this.item.displayOnValue2
              ? true
              : false;
        } else {
          this.display_none_check2 =
            val.value == this.item.displayOnValue2 ? true : false;
        }
      }
      if (val && this.item.displayOn3 && val.key == this.item.displayOn3) {
        if (typeof val.value != "string") {
          this.display_none_check3 =
            JSON.stringify(val.value) == this.item.displayOnValue3
              ? true
              : false;
        } else {
          this.display_none_check3 =
            val.value == this.item.displayOnValue3 ? true : false;
        }
      }
      if (val && this.item.disableOn && val.key == this.item.disableOn) {
        console.log(val.value);
        let d_check = !val.value;
        // let d_check = val.value.find(x => JSON.stringify(x) == this.item.disableOnValue)
        this.disable_check = d_check ? true : false;
      }
      this.rerender = true;
    },
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{
      'd-none':
        (item.displayOn && !display_none_check) ||
        (item.displayOn2 && !display_none_check2) ||
        (item.displayOn3 && !display_none_check3),
    }"
  >
    <Label
      v-if="!item.hideLabel"
      :item="item"
      :model_length="validation.$model.length"
    />
    <div class="img-preview-container" v-if="rerender" :key="imageUrl">
      <img
        v-if="imageUrl"
        :src="imageUrl"
        :alt="item_key === 'cqc_preview' ? 'CQC Rating Badge' : 'logo'"
        class="mr-3 cmd-icon"
        @error="console.error('Image failed to load:', imageUrl)"
      />
      <img
        v-else
        src="@/assets/images/preview.svg"
        alt="logo"
        class="mr-3 cmd-icon"
      />
    </div>
  </div>
</template>
<style scoped>
.img-preview-container img {
  max-height: fit-content;
  max-width: 100%;
}
</style>
